'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VXList = exports.List = exports.VXListLoading = exports.VXListBlank = undefined;

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _core = require('@blueprintjs/core');

var _recompose = require('recompose');

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Wrapper = _glamorous2.default.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: 20
});

var VXListBlank = exports.VXListBlank = function VXListBlank(_ref) {
  var blankLabel = _ref.blankLabel;
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(_core.NonIdealState, { visual: 'circle', description: blankLabel })
  );
};

VXListBlank.propTypes = {
  blankLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};

var StyledSpinner = (0, _glamorous2.default)(_core.Spinner)({
  paddingBottom: 20
});

var VXListLoading = exports.VXListLoading = function VXListLoading(_ref2) {
  var loadingLabel = _ref2.loadingLabel;
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(StyledSpinner, null),
    loadingLabel
  );
};

VXListLoading.propTypes = {
  loadingLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};

var StyledList = _glamorous2.default.div({}, function (_ref3) {
  var isRtl = _ref3.isRtl;
  return {
    direction: isRtl ? 'rtl' : 'ltr'
  };
});

var ListWrapper = _glamorous2.default.div({
  borderTop: '2px solid ' + _.Colors.GREY2,
  marginBottom: 20
});

var List = function List(_ref4) {
  var items = _ref4.items,
      itemRenderer = _ref4.itemRenderer,
      statusLabel = _ref4.statusLabel,
      isRtl = _ref4.isRtl,
      isNarrow = _ref4.isNarrow,
      rest = _objectWithoutProperties(_ref4, ['items', 'itemRenderer', 'statusLabel', 'isRtl', 'isNarrow']);

  return _react2.default.createElement(
    StyledList,
    { isRtl: isRtl },
    statusLabel,
    _react2.default.createElement(
      ListWrapper,
      { isNarrow: isNarrow },
      (0, _map2.default)(function (item) {
        var Renderer = item.renderer || itemRenderer;
        if (!Renderer) {
          console.log('no renderer found', 'item.id', item.id);
          return null;
        }
        return _react2.default.createElement(Renderer, _extends({ key: item.id }, item, rest, { isRtl: isRtl }));
      })(items)
    )
  );
};

exports.List = List;
List.propTypes = _defineProperty({
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    renderer: _propTypes2.default.func
  })),
  itemRenderer: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  isNarrow: _propTypes2.default.bool,
  statusLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
}, 'isRtl', _propTypes2.default.bool);

List.defaultProps = {
  items: []
};

var VXList = exports.VXList = (0, _recompose.compose)((0, _.withListLoading)(VXListLoading), (0, _.withListBlank)(VXListBlank))(List);


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-list/index.js
// module id = 2036
// module chunks = 0